export default async function flushPendingPromises(pendingPromises) {
  if (!pendingPromises?.size) {
    return
  }

  await Promise.allSettled(Array.from(pendingPromises))
}
